
function Header() {
    return (
        <>
            <h1 className="pokemonFont">PokeDex</h1>
        </>
        
    )
}
export default Header